export class JobsCarousel{
  constructor()
  {
      const carousel = document.querySelector('.js-carousel');
      const dotsContainer = document.querySelector('.js-carousel-dots-container');
      const itemsPerPage = 5;
    
      // Calculate the number of dots based on the total number of items
      if(carousel && dotsContainer)
      {
        const totalItems = carousel.children.length;
        const totalDots = Math.ceil(totalItems / itemsPerPage);

        for (let i = 0; i < totalDots; i++) {
          const dot = document.createElement('li');
          dot.className = 'dot';
          dot.addEventListener('click', function () {
            showItems(i);
          });
          dotsContainer.appendChild(dot);
        }
        showItems(0);
      
        function showItems(page) {
          const start = page * itemsPerPage;
          const end = start + itemsPerPage;

          for (let i = 0; i < totalItems; i++) {
            if(!carousel.children[i].classList.contains('is-hidden'))
            {
              carousel.children[i].classList.add('is-hidden');
            }
          }

          for (let i = start; i < end && i < totalItems; i++) {
            if(carousel.children[i].classList.contains('is-hidden'))
            {
              carousel.children[i].classList.remove('is-hidden');
            }
          }
        
          const dots = dotsContainer.getElementsByClassName('dot');
          for (let i = 0; i < dots.length; i++) {
            dots[i].classList.remove('active');
          }
          dots[page].classList.add('active');
        }
      }
  }
}
